<template>
  <div>
    <Dialog
      v-model:visible="mostrarModal"
      :style="{ width: '750px' }"
      :header="data_objetivo.id ? 'Editar Objetivo' : 'Nuevo Objetivo de Comisión'"
      :modal="true"
      :maximizable="true"
      class="p-fluid"
      @hide="ocultarDialog"
    >
      <div class="formgrid grid p-2">
        <div class="field col-6">
          <span><strong>NOMBRE: </strong><span class="p-invalid">*</span></span>
          <InputText v-model.trim="data_objetivo.nombre" placeholder="Ej: Comisión Lavados Mayo 2026" class="w-full" />
          <small class="p-invalid" v-if="errors.nombre">{{ errors.nombre[0] }}</small>
        </div>

        <div class="field col-12" v-if="sucursales.length > 1">
          <span><strong>SUCURSAL: </strong><span class="p-invalid">*</span></span>
          <Dropdown
            v-model="data_objetivo.sucursal_id"
            :options="sucursales"
            optionLabel="nombre"
            optionValue="id"
            placeholder="Seleccione..."
            class="w-full"
          />
          <small class="p-invalid" v-if="errors.sucursal_id">{{ errors.sucursal_id[0] }}</small>
        </div>

        <div class="field col-12 md:col-3">
          <span><strong>MES: </strong><span class="p-invalid">*</span></span>
          <Dropdown
            v-model="data_objetivo.mes"
            :options="meses"
            optionLabel="label"
            optionValue="value"
            placeholder="Seleccione mes..."
            class="w-full"
          />
          <small class="p-invalid" v-if="errors.mes">{{ errors.mes[0] }}</small>
        </div>

        <div class="field col-12 md:col-3">
          <span><strong>AÑO: </strong><span class="p-invalid">*</span></span>
          <InputText type="number" v-model="data_objetivo.anio" placeholder="2026" class="w-full" />
          <small class="p-invalid" v-if="errors.anio">{{ errors.anio[0] }}</small>
        </div>

        <div class="field col-12">
          <span><strong>SERVICIOS QUE APLICAN: </strong><span class="p-invalid">*</span></span>
          <MultiSelect
            v-model="productosSeleccionados"
            :options="productos"
            optionLabel="descripcion"
            optionValue="id"
            placeholder="Seleccione servicios..."
            :filter="true"
            display="chip"
            class="w-full"
          />
          <small class="p-invalid" v-if="errors.productos">{{ errors.productos[0] }}</small>
        </div>

        <div class="field col-12">
          <div class="flex justify-content-between align-items-center mb-2">
            <div>
              <span><strong>ESCALAS DE COMISION: </strong></span>
            </div>
            <Button
              icon="pi pi-plus"
              label="AGREGAR"
              class="p-button-outlined p-button-sm p-button-info"
              style="width: auto"
              @click="agregarEscala"
            />
          </div>
          <small class="p-invalid" v-if="errors.escalas">{{ errors.escalas[0] }}</small>

          <table style="border-collapse: collapse; font-size: 13px; width: 100%">
            <thead>
              <tr style="background: #1e3a5f; color: #fff">
                <th style="padding: 8px; text-align: center; width: 50px">#</th>
                <th style="padding: 8px; text-align: right">DESDE (servicios)</th>
                <th style="padding: 8px; text-align: right">HASTA (servicios)</th>
                <th style="padding: 8px; text-align: right">PAGO (Bs.)</th>
                <th style="padding: 8px; width: 40px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!escalas.length">
                <td colspan="5" style="padding: 12px; text-align: center; color: #e74c3c; font-style: italic">
                  Agregue al menos una escala
                </td>
              </tr>
              <tr
                v-for="(escala, index) in escalas"
                :key="index"
                :style="index % 2 === 0 ? 'background:#f8f9fa' : 'background:#fff'"
              >
                <td style="padding: 5px 8px; text-align: center; font-weight: 700; color: #1e3a5f; font-size: 15px">
                  {{ index + 1 }}
                </td>
                <td style="padding: 3px 5px">
                  <InputNumber
                    v-model="escala.desde"
                    :minFractionDigits="0"
                    :maxFractionDigits="0"
                    :min="index > 0 ? (escalas[index - 1].hasta ?? 0) + 1 : 0"
                    inputStyle="text-align:right; font-weight:700; font-size:14px;"
                  />
                </td>
                <td style="padding: 3px 5px">
                  <InputNumber
                    v-model="escala.hasta"
                    :minFractionDigits="0"
                    :maxFractionDigits="0"
                    :min="escala.desde ?? 0"
                    placeholder="Sin límite"
                    inputStyle="text-align:right; font-weight:700; font-size:14px;"
                  />
                </td>
                <td style="padding: 3px 5px">
                  <InputNumber
                    v-model="escala.monto"
                    :minFractionDigits="2"
                    :maxFractionDigits="2"
                    :min="0"
                    inputStyle="text-align:right; font-weight:700; font-size:14px; color:#27ae60;"
                  />
                </td>
                <td style="padding: 3px 5px; text-align: center">
                  <Button
                    icon="pi pi-trash"
                    class="p-button-danger p-button-text p-button-sm"
                    @click="quitarEscala(index)"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <div
            v-if="escalas.length"
            class="mt-2 p-2 border-round"
            style="background: #e8f4fd; font-size: 12px; color: #2980b9"
          >
            <i class="pi pi-info-circle mr-1"></i>
            <span v-for="(e, i) in escalas" :key="i">
              <strong>E{{ i + 1 }}:</strong> {{ e.desde ?? 0 }}–{{ e.hasta ?? '∞' }} servicios →
              <strong>Bs. {{ e.monto ?? 0 }}</strong>
              <span v-if="i < escalas.length - 1"> · </span>
            </span>
          </div>
        </div>
      </div>

      <template #footer>
        <Button label="CANCELAR" icon="pi pi-times" class="p-button-secondary" @click="ocultarDialog" />
        <Button
          :label="data_objetivo.id ? 'ACTUALIZAR' : 'GUARDAR'"
          icon="pi pi-save"
          class="p-button-info"
          :loading="enviado"
          @click="guardar"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import ObjetivoComisionService from '@/service/ObjetivoComisionService'

export default {
  emits: ['closeModal', 'actualizarListado'],
  props: {
    show: { type: Boolean, default: false },
    objetivo: { type: Object, default: () => ({}) },
    sucursales: { type: Array, default: () => [] },
    productos: { type: Array, default: () => [] }
  },

  data() {
    return {
      mostrarModal: this.show,
      data_objetivo: {},
      enviado: false,
      errors: {},
      productosSeleccionados: [],
      escalas: [],
      meses: [
        { label: 'ENERO', value: 1 },
        { label: 'FEBRERO', value: 2 },
        { label: 'MARZO', value: 3 },
        { label: 'ABRIL', value: 4 },
        { label: 'MAYO', value: 5 },
        { label: 'JUNIO', value: 6 },
        { label: 'JULIO', value: 7 },
        { label: 'AGOSTO', value: 8 },
        { label: 'SEPTIEMBRE', value: 9 },
        { label: 'OCTUBRE', value: 10 },
        { label: 'NOVIEMBRE', value: 11 },
        { label: 'DICIEMBRE', value: 12 }
      ]
    }
  },

  created() {
    this.objetivoComisionService = new ObjetivoComisionService()
  },

  methods: {
    agregarEscala() {
      const ultima = this.escalas[this.escalas.length - 1]
      const desde = ultima && ultima.hasta != null ? Math.round(ultima.hasta) + 1 : 0
      this.escalas.push({ escala: this.escalas.length + 1, desde, hasta: null, monto: null })
    },

    quitarEscala(index) {
      this.escalas.splice(index, 1)
      this.escalas.forEach((e, i) => {
        e.escala = i + 1
      })
    },

    validar() {
      this.errors = {}
      if (!this.data_objetivo.nombre) this.errors.nombre = ['Requerido']
      if (!this.data_objetivo.sucursal_id) this.errors.sucursal_id = ['Requerido']
      if (!this.data_objetivo.mes) this.errors.mes = ['Requerido']
      if (!this.data_objetivo.anio) this.errors.anio = ['Requerido']
      if (!this.productosSeleccionados.length) this.errors.productos = ['Seleccione al menos un servicio']
      if (!this.escalas.length) this.errors.escalas = ['Agregue al menos una escala']
      for (let i = 1; i < this.escalas.length; i++) {
        if (this.escalas[i - 1].hasta != null && this.escalas[i].desde <= this.escalas[i - 1].hasta) {
          this.errors.escalas = [`Escala ${i + 1}: DESDE debe ser mayor al HASTA anterior`]
          break
        }
      }
      return !Object.keys(this.errors).length
    },

    async guardar() {
      if (!this.validar()) return
      this.enviado = true
      try {
        const payload = { ...this.data_objetivo, productos: this.productosSeleccionados, escalas: this.escalas }
        const res = this.data_objetivo.id
          ? await this.objetivoComisionService.update(payload)
          : await this.objetivoComisionService.store(payload)
        if (res.errors) {
          this.errors = res.errors
        } else if (!res.success) {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: res.message, life: 4000 })
        } else {
          this.$toast.add({ severity: 'success', summary: 'Éxito', detail: res.message, life: 3000 })
          this.$emit('actualizarListado')
          this.ocultarDialog()
        }
      } catch {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar', life: 4000 })
      } finally {
        this.enviado = false
      }
    },

    ocultarDialog() {
      this.errors = {}
      this.enviado = false
      this.mostrarModal = false
      this.$emit('closeModal')
    },

    precargar(val) {
      this.data_objetivo = { ...val }
      this.productosSeleccionados = val.productos?.map((p) => p.producto_id) ?? []
      this.escalas = val.escalas?.map((e) => ({ ...e })) ?? []
    },

    inicializarNuevo() {
      const sucursal_id = this.sucursales.length === 1 ? this.sucursales[0].id : null
      const now = new Date()
      this.data_objetivo = { sucursal_id, mes: now.getMonth() + 1, anio: now.getFullYear() }
      this.productosSeleccionados = []
      this.escalas = []
      this.errors = {}
    }
  },

  watch: {
    show(val) {
      this.mostrarModal = val
    },
    objetivo(val) {
      val.id ? this.precargar(val) : this.inicializarNuevo()
    },
    sucursales(val) {
      if (val.length === 1 && !this.data_objetivo.id) this.data_objetivo.sucursal_id = val[0].id
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';
.p-invalid {
  color: red;
}
table tbody tr:hover {
  background: #eaf4ff !important;
}
</style>
